import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function EnterpriseQualityManagementSystemEQms() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'IT Solutions for Pharma', 'Enterprise Quality Management System - (eQMS)']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          IT Solutions for Pharma
        </h2>
        {/* Section Title */}
        <div className="flex items-center gap-2 mb-2">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Enterprise Quality Management System - (eQMS)
          </h3>
        </div>

        {/* Intro */}
        <h4 className="text-md font-bold text-[#05326D] mb-4 pl-3">
          Digitally Transforming Quality Processes Across Pharma, Life Sciences & Healthcare
        </h4>

        <p className="mb-4 text-[#05326D]">
          eQMS is a robust, cloud-based Enterprise Quality Management Solution designed specifically for the pharmaceutical, biotechnology, medical device, and healthcare industries. Developed to meet the evolving demands of regulated environments, eQMS streamlines quality operations, reduces compliance risks, and enhances operational efficiency—whether you're a startup or a global enterprise.
        </p>
        <p className="mb-8 text-[#05326D]">
          Powered by multi-factor authentication, configurable workflows, and full compliance with US FDA, HIPAA, and global regulatory standards, eQMS offers a secure, scalable, and intelligent platform for managing quality processes end-to-end.
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        {/* Industries Served */}
        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Industries Served
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Pharmaceuticals</p>
        <p className="ml-2 mt-2 text-[#05326D]">Biologics & Biotechnology</p>
        <p className="ml-2 mt-2 text-[#05326D]">Medical Devices</p>
        <p className="ml-2 mt-2 text-[#05326D]">Cosmetics</p>
        <p className="ml-2 mt-2 text-[#05326D]">Nutraceuticals & Food Supplements</p>
        <p className="ml-2 mt-2 text-[#05326D]">Life Sciences & Healthcare</p>


        {/* Core Modules */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Core Modules
          </h3>
        </div>
        <h4 className="text-md font-bold text-[#05326D] mb-2">Core Modules</h4>
        <p className="ml-2 mt-2 text-[#05326D] font-bold">Quality Processes</p>
        <p className="ml-2 mt-2 text-[#05326D]">Change Control</p>
        <p className="ml-2 mt-2 text-[#05326D]">Deviation Management</p>
        <p className="ml-2 mt-2 text-[#05326D]">Investigations</p>
        <p className="ml-2 mt-2 text-[#05326D]">CAPA (Corrective & Preventive Actions)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Market Complaint Handling</p>
        <p className="ml-2 mt-2 text-[#05326D]">OOS/OOT Management</p>
        <p className="ml-2 mt-2 text-[#05326D] mb-2">Audit Planning & Execution</p>
        <p className="ml-2 mt-2 text-[#05326D] font-bold mb-2">Document Control</p>
        <p className="ml-2 mt-2 text-[#05326D]">SOP Lifecycle Management</p>
        <p className="ml-2 mt-2 text-[#05326D]">Controlled Copy Release</p>
        <p className="ml-2 mt-2 text-[#05326D] mb-2">Archival & Retrieval</p>
        <p className="ml-2 mt-2 text-[#05326D] font-bold mb-">Training Management</p>
        <p className="ml-2 mt-2 text-[#05326D]">Electronic Training Records</p>
        <p className="ml-2 mt-2 text-[#05326D]">Role-Based Training Assignment</p>
        <p className="ml-2 mt-2 text-[#05326D]">eLearning Integration & Quiz Engine</p>
        <p className="ml-2 mt-2 text-[#05326D]">Performance Tracking & Evaluation</p>


        {/* Key Functional Highlights */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Key Functional Highlights
          </h3>
        </div>

        <p className="ml-2 mt-2 text-[#05326D]">Change Control: Automated impact and risk assessments within change requests, enabling informed decision-making and regulatory compliance.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Deviation Management: Systematic tracking and investigation of deviations with real-time alerts and CAPA integration, aligned with 21 CFR Part 11 and EU GMP.</p>
        <p className="ml-2 mt-2 text-[#05326D]">CAPA: Root cause analysis, corrective action planning, and effectiveness monitoring—ensuring issues are resolved and prevented from recurrence.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Complaint Management: Structured workflows for internal and external complaint handling, with embedded CAPA and root cause evaluation to drive continuous improvement.</p>
        <p className="ml-2 mt-2 text-[#05326D]">OOS/OOT: Integrated handling of Out-of-Specification and Out-of-Trend results, with traceable links to change control and CAPA actions.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Audit Management: Comprehensive audit planning, checklist creation, non-conformance tracking, and CAPA implementation with dynamic reporting.</p>
        <p className="ml-2 mt-2 text-[#05326D]">SOP Management: End-to-end SOP lifecycle control—from authoring and approval to distribution and archival—with version control and audit trails.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Training Management: Role-based training assignment, automated quiz generation, and performance tracking—ensuring workforce readiness and regulatory compliance.</p>


        {/* Key Benefits */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Key Benefits of eQMS
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Field-Level Audit Trails</p>
        <p className="ml-2 mt-2 text-[#05326D]">Flexible, Industry-Fit Workflows</p>
        <p className="ml-2 mt-2 text-[#05326D]">Compliance with 21 CFR Part 11, EU GMP, and HIPAA</p>
        <p className="ml-2 mt-2 text-[#05326D]">Real-Time Dashboards & Notifications</p>
        <p className="ml-2 mt-2 text-[#05326D]">Seamless Integration with Microsoft 365</p>
        <p className="ml-2 mt-2 text-[#05326D]">Color-Coded Status Tracking</p>
        <p className="ml-2 mt-2 text-[#05326D]">Dynamic Reports & Trend Analysis</p>
        <p className="ml-2 mt-2 text-[#05326D]">Globally Validated by Regulatory Authorities</p>
        <p className="ml-2 mt-2 text-[#05326D]">Supports Virtual Audits & Remote Operations</p>


        {/* Who Benefits */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Who Benefits from eQMS?
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">API Manufacturers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Formulation Units</p>
        <p className="ml-2 mt-2 text-[#05326D]">Intermediate & Excipient Producers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Contract Manufacturing Organizations (CMOs)</p>
        <p className="ml-2 mt-2 text-[#05326D]">R&D Centers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Packaging Material Suppliers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory & Quality Stakeholders Across the Value Chain</p>
        <p className="ml-2 mt-2 text-[#05326D]">FDAc enables seamless implementation of eQMS across your organization, ensuring total control over data, compliance, and quality operations. Especially in times of disruption—like the COVID era—eQMS empowers teams to operate uninterrupted, securely, and globally.</p>

      </div>
    </div>
  );
}

export default EnterpriseQualityManagementSystemEQms;
